
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard } from '@/components';
import { useAccountTransaction } from '@/modules/account/app/model/transaction';
import { TableColumn, TableColumnType } from '@/components/table/types';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';

export default defineComponent({
    name: ROUTE_NAME_ACCOUNT.APP.TRANSACTION,
    components: { AppTable, AppCard },
    setup() {
        const { list, total, fetchList, query, accountId, transactionColumnByType } = useAccountTransaction();

        const columns: TableColumn[] = [
            { type: TableColumnType.Index, label: '#' },
            { type: TableColumnType.Text, label: 'Type', key: 'type' },
            { type: TableColumnType.Text, label: 'Title', key: 'title' },
            { type: TableColumnType.Text, label: 'Amount', key: 'amount' },
            {
                type: TableColumnType.Text,
                label: transactionColumnByType.value.label,
                key: transactionColumnByType.value.field
            },
            { type: TableColumnType.Text, label: 'Store', key: 'store' },
            { type: TableColumnType.DateTime, label: 'Date Time', key: 'createTime' },
            { type: TableColumnType.Text, label: 'Detail', key: 'detail' }
        ];

        onMounted(fetchList);

        return { list, total, columns, fetchList, query, accountId, transactionColumnByType };
    }
});
